e4.product.variants = {
    debug: false,
    init: function () {
        var jProduct = jQuery( '.js-e-product' );
        if ( jProduct.data( 'hasVariants' ) === true ) {
            e4.product.variants.event = e4.util.registerEvents( 'change changed', 'product.variants' );
            jProduct.find( '.js-e-product-form' ).each( function ( intIndex, domForm ) {
                e4.product.variants.updateAvailableOptionsInAllGroups( domForm );
                e4.product.variants.loadJsonProduct( domForm );
            } );
            e4.product.variants.bindEvents();
        }
    },
    bindEvents: function () {
        jQuery( '.js-e-product-form' ).one( 'change', function ( event ) {
            var strProductId = e4.product.variants.getProductId( event.currentTarget );
            //e4.product.variants.preloadImages( strProductId );
        } ).find( '.js-e-product-form-variant-group-input' ).on( 'change', function ( event ) {
            e4.product.variants.changeVariant( event.target );
        } );
    },
    loadJsonProduct: function ( domForm ) {
        var dfdReturnValue = null,
            strProductId = e4.product.variants.getProductId( domForm ),
            strVariantId = e4.product.variants.getVariantId( domForm );
        if ( e4.product.variants.isVariantIdValid( strProductId, strVariantId ) === true ) {
            dfdReturnValue = e4.jsonpublisher.getJsonFromUrl( e4.settings.ecom.product.url, {
                productId: e4.product.variants.getProductId( domForm ),
                variantId: e4.product.variants.getVariantId( domForm ),
            } ).done( function ( jsonProduct ) {
                // Update internal json data object used as source for all json publishers without their own url source.
                // console.log( jsonProduct )
                e4.data.set( jsonProduct.id, jsonProduct );
            } );
        }
        else {
            dfdReturnValue = jQuery.Deferred().reject( 'Failed to load json variant product, productId and/or variantId is not valid.' );
            dfdReturnValue.fail( function () {
                console.warn( [
                    arguments,
                    e4.settings.ecom.product.url,
                    {
                        productId: e4.product.variants.getProductId( domForm ),
                        variantId: e4.product.variants.getVariantId( domForm ),
                    }
                ], e4.product.variants.debug );
            } );
        }
        return dfdReturnValue.promise();
    },
    preloadImages: function ( strProductId ) {
        var arrVariantImages = [],
            fnLoadImages = function ( arrImageSrc, intIndex ) {
                intIndex = intIndex || 0;
                if ( arrImageSrc && arrImageSrc.length > intIndex ) {
                    var domImg = new Image();
                    domImg.onload = function () {
                        fnLoadImages( arrImageSrc, intIndex + 1 );
                    };
                    domImg.onerror = function () {
                        fnLoadImages( arrImageSrc, intIndex + 1 );
                    };
                    domImg.src = arrImageSrc[ intIndex ];
                }
            },
            jsonVariantCombinations = e4.data.get( e4.product.variants.getJsonPropertyPath( strProductId ) );
        jQuery.each( jsonVariantCombinations, function ( strKey, objVariant ) {
            //arrVariantImages.push( objVariant.imagePrimary.small );
            arrVariantImages.push( objVariant.imagePrimary.large );
            //jQuery.each( objVariant.imageDetails, function ( index, objImageUrl ) {
            //arrVariantImages.push( objImageUrl.small );
            //arrVariantImages.push( objImageUrl.large );
            //} );
        } );
        fnLoadImages( arrVariantImages );
        //e4.util.debug( ['preloadImages', arrVariantImages], e4.product.variants.debug );
    },
    changeVariant: function ( domInput ) {
        var jProductForm = jQuery( domInput.form ),
            jProduct = jProductForm.closest( '.js-e-product' ),
            strProductId = e4.product.variants.getProductId( domInput.form ),
            strVariantId = null, // Set initial value and wait for updateAvailableOptionsInAllGroups to run before getting the value, as it can change the selected options.
            arrJsonPublishers = {
                withUrlSource: [],
                withoutUrlSource: []
            };
        e4.product.variants.updateAvailableOptionsInAllGroups( domInput.form );
        strVariantId = e4.product.variants.getVariantId( domInput.form );


        if ( e4.product.variants.isVariantIdValid( strProductId, strVariantId ) === true ) {
            jProduct.trigger( e4.product.variants.event.change );
            e4.util.debug( [
                'Changing variant to',
                strVariantId,
                'and updating content.'
            ], e4.product.variants.debug );
            // Get all json publishers inside product element that needs to be updated on variant change.
            jProduct.find( '.js-e-jsonpublisher' ).each( function ( index, domNode ) {
                var jJsonPublisher = jQuery( domNode );
                // Collect elements with and without url sources in separate collections to update so they can be updated on different callbacks.
                if ( e4.util.looksLikeUrl( jJsonPublisher.data( 'jsonSrc' ) ) === true ) {
                    arrJsonPublishers.withUrlSource.push( domNode );
                }
                else {
                    arrJsonPublishers.withoutUrlSource.push( domNode );
                }
            } );
            e4.product.variants.setVariantId( domInput.form, strVariantId );
            jProductForm.addClass( 'is-loading' );
            // Get new json product data to update all json publishers without their own url source.
            e4.product.variants.loadJsonProduct( domInput.form ).done( function ( jsonProduct ) {
                e4.product.variants.setDetailsOnElementsWithoutUrlSource( jProduct, jsonProduct, arrJsonPublishers.withoutUrlSource );
                e4.product.variants.setUrl( jsonProduct );
                jProductForm.removeClass( 'is-loading' );
                jProduct.trigger( e4.product.variants.event.changed, jsonProduct );
            } );
            // Update all json publishers with url source.
            e4.product.variants.setDetailsOnElementsWithUrlSource( jProduct, strProductId, strVariantId, arrJsonPublishers.withUrlSource );
        }
        else {
            e4.product.variants.clearVariantId( domInput.form );
            e4.util.debug( [
                'Cannot change variant.',
                strVariantId,
                'is not a valid variantId.'
            ], e4.product.variants.debug );
        }
    },
    isVariantIdValid: function ( strProductId, strVariantId ) {
        // console.log(jQuery.inArray( strVariantId, e4.data.get( strProductId + '_VariantCombinationIds' ) ),e4.data.get( strProductId + '_VariantCombinationIds' ), strVariantId)
        return jQuery.inArray( strVariantId, e4.data.get( strProductId + '_VariantCombinationIds' ) ) > -1;
    },
    getVariantId: function ( domForm ) {
        var arrGroupsValue = [];
        jQuery( domForm ).find( '.js-e-product-form-variant-form-group' ).each( function ( intIndex, domNode ) {
            var jGroup = jQuery( domNode ),
                jGroupInput = e4.product.variants.getGroupInput( jGroup );
            arrGroupsValue.push( e4.product.variants.getGroupInputValue( jGroupInput ) );
        } );
        return arrGroupsValue.join( '.' );
    },
    setVariantId: function ( domForm, strVariantId ) {
        jQuery( domForm ).find( 'input[name="VariantID"]' ).val( strVariantId );
    },
    clearVariantId: function ( domForm ) {
        e4.product.variants.setVariantId( domForm, '' );
    },
    getProductId: function ( domForm ) {
        return jQuery( domForm ).find( 'input[name="ProductID"]' ).val();
    },
    getAvailableOptionsForNextGroup: function ( objVariantMap ) {
        var objOptions = null;
        if ( objVariantMap !== null && objVariantMap.options !== undefined ) {
            objOptions = objVariantMap.options;
        }
        return objOptions;
    },
    getNextVariantMap: function ( strVariantOptionId, objVariantMap ) {
        var objGroup = null;
        if ( objVariantMap !== null && objVariantMap.options !== undefined && objVariantMap.options[ strVariantOptionId ] !== undefined ) {
            objGroup = objVariantMap.options[ strVariantOptionId ];
        }
        e4.util.debug( [
            'Getting next map from',
            objVariantMap,
            'with key',
            strVariantOptionId,
            'returning',
            objGroup
        ], e4.product.variants.debug );
        return objGroup;
    },
    getNextGroupId: function ( objVariantMap ) {
        var strGroupId = '';
        if ( objVariantMap !== null && objVariantMap.options !== undefined ) {
            jQuery.each( objVariantMap.options, function ( strKey, objValue ) {
                strGroupId = objValue.groupId;
                // Return false to break jQuery.each loop.
                return false;
            } );
        }
        return strGroupId;
    },
    getNextGroup: function ( jGroup, jGroups ) {
        var intNextGroupIndex = jGroups.index( jGroup ) + 1;
        return jGroups.eq( intNextGroupIndex );
    },
    getGroupName: function ( jGroup ) {
        return jGroup.find( 'label' ).first().text();
    },
    getGroupInput: function ( jGroup ) {
        return jGroup.find( 'select,input[type="radio"]' );
    },
    getGroupInputType: function ( jGroupInput ) {
        var strInputType = null,
            domInput = jGroupInput.get( 0 ),
            strTypeAttr = jGroupInput.attr( 'type' );
        if ( domInput !== undefined ) {
            if ( strTypeAttr !== undefined ) {
                strInputType = strTypeAttr.toLowerCase();
            }
            else {
                strInputType = domInput.nodeName.toLowerCase();
            }
        }
        return strInputType;
    },
    getGroupInputValue: function ( jGroupInput ) {
        var strInputValue = null;
        if ( e4.product.variants.getGroupInputType( jGroupInput ) === 'select' ) {
            strInputValue = jGroupInput.val();
        }
        else {
            strInputValue = jGroupInput.filter( ':checked' ).val();
        }
        if ( strInputValue === undefined || strInputValue === '' ) {
            strInputValue = null;
        }
        return strInputValue;
    },
    getGroupInputOptions: function ( jGroupInput ) {
        var jGroupInputOptions = jGroupInput;
        if ( e4.product.variants.getGroupInputType( jGroupInput ) === 'select' ) {
            jGroupInputOptions = jGroupInputOptions.find( 'option' ).not( '[value=""]' );
        }
        return jGroupInputOptions;
    },
    getGroupInputOptionName: function ( jGroupInput, jGroupInputOption ) {
        var strOptionText = null;
        if ( e4.product.variants.getGroupInputType( jGroupInput ) === 'select' ) {
            strOptionText = jGroupInputOption.text();
        }
        else {
            strOptionText = jGroupInputOption.attr( 'title' );
            if ( strOptionText === undefined ) {
                strOptionText = jGroupInputOption.closest( 'label' ).text();
            }
        }
        return strOptionText;
    },
    deSelectGroupOptions: function ( jGroupInput ) {
        if ( e4.product.variants.getGroupInputType( jGroupInput ) === 'select' ) {
            jGroupInput.val( '' );
        }
        else {
            e4.product.variants.getGroupInputOptions( jGroupInput ).prop( 'checked', false );
        }
    },
    selectGroupInputOption: function ( jGroupInput, jGroupInputOption ) {
        if ( e4.product.variants.getGroupInputType( jGroupInput ) === 'select' ) {
            jGroupInputOption.prop( 'selected', true );
        }
        else {
            jGroupInputOption.prop( 'checked', true );
        }
    },
    isOptionSelected: function ( jGroupInput, jGroupInputOption ) {
        var isSelected;
        if ( e4.product.variants.getGroupInputType( jGroupInput ) === 'select' ) {
            isSelected = jGroupInputOption.prop( 'selected' ) === true;
        }
        else {
            isSelected = jGroupInputOption.prop( 'checked' ) === true;
        }
        return isSelected;
    },
    enableGroupInputOptions: function ( jGroupInput ) {
        e4.product.variants.getGroupInputOptions( jGroupInput ).prop( 'disabled', false );
    },
    updateAvailableOptionsInAllGroups: function ( domForm ) {
        var strProductId = e4.product.variants.getProductId( domForm ),
            jGroups = jQuery( domForm ).find( '.js-e-product-form-variant-form-group' ),
            objVariantMap = e4.data.get( [
                strProductId,
                'VariantCombinationTree'
            ].join( '_' ) ),
            isGroupSelectionCleared = false;

        e4.util.debug( [ '--- --- updateAvailableOptionsInAllGroups --- START', objVariantMap ], e4.product.variants.debug );

        jGroups.each( function ( intIndex, domNode ) {
            var jGroup = jQuery( domNode ),
                jGroupInput = e4.product.variants.getGroupInput( jGroup ),
                strVariantOptionId = e4.product.variants.getGroupInputValue( jGroupInput ),
                jNextGroup = e4.product.variants.getNextGroup( jGroup, jGroups ),
                jNextGroupInput = e4.product.variants.getGroupInput( jNextGroup ),
                jNextGroupInputOptions = e4.product.variants.getGroupInputOptions( jNextGroupInput ),
                objAvailableOptionsForNextGroup = null;

            e4.util.debug( [
                'GROUP:',
                e4.product.variants.getGroupName( jGroup ),
                'VALUE:',
                e4.product.variants.getGroupInputValue( jGroupInput ),
                'isGroupSelectionCleared is',
                isGroupSelectionCleared
            ], e4.product.variants.debug );

            // Get next level from variant map.
            objVariantMap = e4.product.variants.getNextVariantMap( strVariantOptionId, objVariantMap );
            // Get options from variant map.
            objAvailableOptionsForNextGroup = e4.product.variants.getAvailableOptionsForNextGroup( objVariantMap );

            // Release all options in group if previous group selection was cleared or has no selected options.
            if ( isGroupSelectionCleared === true || objAvailableOptionsForNextGroup === null ) {
                isGroupSelectionCleared = true;
                e4.product.variants.enableGroupInputOptions( jNextGroupInput );
                e4.util.debug( [
                        'Enable all group options on',
                        e4.product.variants.getGroupName( jNextGroup ),
                        'after deSelectGroupOptions on previous group.'
                    ], e4.product.variants.debug
                );
            }
            else {
                jNextGroupInputOptions.prop( 'disabled', function () {
                    var jNextGroupOption = jQuery( this ),
                        strOptionValue = jNextGroupOption.attr( 'value' ),
                        isOptionAvailable = false;
                    // Loop all available options on next group and save disabled state.
                    for ( var strVariantOptionId in objAvailableOptionsForNextGroup ) {
                        if ( strOptionValue === strVariantOptionId ) {
                            isOptionAvailable = true;

                            // If we find a match, we dont need to look any further.
                            break;
                        }
                    }
                    e4.util.debug( [
                        'Option',
                        e4.product.variants.getGroupInputOptionName( jNextGroupInput, jNextGroupOption ),
                        '(',
                        strOptionValue,
                        ') isOptionAvailable: ',
                        isOptionAvailable
                    ], e4.product.variants.debug );
                    // If current option already is selected and has been disabled, we need to reset the current
                    // select/input.
                    if ( isOptionAvailable === false && e4.product.variants.isOptionSelected( jNextGroupInput, jNextGroupOption ) === true ) {
                        e4.product.variants.deSelectGroupOptions( jNextGroupInput );
                        isGroupSelectionCleared = true;
                        e4.util.debug( [
                            'Group selection is cleared on',
                            e4.product.variants.getGroupName( jNextGroup ),
                            'because selected option',
                            e4.product.variants.getGroupInputOptionName( jNextGroupInput, jNextGroupOption ),
                            '(',
                            strOptionValue,
                            ') was unavailable and has been deselected and disabled.'
                        ], e4.product.variants.debug );
                    }

                    // Return disabled state to filter function.
                    return isOptionAvailable === false;
                } );

                // Auto selct first available option in group if settings and conditions allow it.
                if ( e4.product.variants.shallWeAutoSelectFirstAvailableOption( jNextGroupInputOptions, isGroupSelectionCleared ) === true ) {
                    var jNextGroupInputOptionsSelectable = jNextGroupInputOptions.not( ':disabled' );
                    e4.product.variants.selectGroupInputOption( jNextGroupInput, jNextGroupInputOptionsSelectable.first() );
                    isGroupSelectionCleared = false;
                    e4.util.debug( [
                        'Auto selecting first option',
                        e4.product.variants.getGroupInputOptionName( jNextGroup, jNextGroupInputOptionsSelectable.first() ),
                        '(',
                        e4.product.variants.getGroupInputValue( jNextGroupInput ),
                        ') in group',
                        e4.product.variants.getGroupName( jNextGroup ),
                        'because group selection was unavailable and has been cleared.'
                    ], e4.product.variants.debug );
                }
            }
        } );
        e4.util.debug( [ '--- --- updateAvailableOptionsInAllGroups --- END' ], e4.product.variants.debug );
    },
    shallWeAutoSelectFirstAvailableOption: function ( jGroupInputOptions, isGroupSelectionCleared ) {
        var boolAutoSelect = false;
        if ( e4.settings.ecom.variants.autoSelect === true && isGroupSelectionCleared === true && jGroupInputOptions.not( ':disabled' ).length > 0 ) {
            boolAutoSelect = true;
        }
        return boolAutoSelect;
    },
    getJsonPropertyPath: function ( strProductId, strVariantId ) {
        var strPropertyPath = null,
            arrPropertyPath = [];
        if ( strProductId !== undefined && strProductId !== '' ) {
            arrPropertyPath.push( strProductId );
            arrPropertyPath.push( 'variantCombinations' );
            if ( strVariantId !== undefined && strVariantId !== '' ) {
                arrPropertyPath.push( strVariantId );
            }
            strPropertyPath = arrPropertyPath.join( '.' );
        }
        return strPropertyPath;
    },
    /* jshint ignore:start */
    setDetailsOnElementsWithUrlSource: function ( jProduct, strProductId, strVariantId, arrJsonPublishersWithUrlSource
    ) {
        var objJsonSettings = {
            jsonSrcGetParams: {
                productId: strProductId,
                variantId: strVariantId
            }
        };
        jQuery.each( arrJsonPublishersWithUrlSource, function ( index, domNode ) {
            e4.jsonpublisher.reload( domNode, objJsonSettings );
        } );
    },
    /* jshint ignore:end */
    setDetailsOnElementsWithoutUrlSource: function ( jProduct, jsonProduct, arrJsonPublishersWithoutUrlSource ) {
        var objJsonSettings = {};
        jQuery.each( arrJsonPublishersWithoutUrlSource, function ( index, domNode ) {
            e4.jsonpublisher.reload( domNode, objJsonSettings );
        } );

        jProduct.find( '.js-e-product-name' ).html( jsonProduct.name );
        jProduct.find( '.js-e-product-number' ).html( jsonProduct.number );
        jProduct.find( '.js-e-product-price' ).html( jsonProduct.price );
    },
    setUrl: function ( jsonProduct ) {
        if ( jsonProduct.link !== undefined && jsonProduct.link.indexOf( '/' ) === 0 ) {
            history.replaceState( null, '', jsonProduct.link );
        }
    }
};
